export default {
  vipUpgrade: {
    title: '¡Felicidades!!',
    message: 'Has sido ascendido de VIP{from} a VIP{to}',
    subtitle: 'Gracias por tu apoyo. Tu nuevo nivel trae\nservicios exclusivos y privilegios especiales.',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
